import { memo, PropsWithChildren, useEffect } from 'react';
import persistentState from './persistent-state';

const PersistentStateRoot = ({ children }: PropsWithChildren<{}>) => {
  useEffect(() => {
    const unsubscribe = persistentState.subscribe((key: any, value: any) => {});
    return unsubscribe;
  }, []);

  return <>{children}</>;
};

export default memo(PersistentStateRoot);
